


import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronUp, Filter, RotateCcw } from "feather-icons-react";
// import Table from "../../../core/pagination/datatableReports";
import {Table} from "antd";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useEffect } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import * as XLSX from "xlsx";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchSettings,
  fetchCustomer,
} from "../../../redux/userSetting";
import { setheadertoggle } from "../../../redux/toggle";
import { renderTooltip } from "../../../redux/helper";
import { DatePicker, Select, Tabs } from "antd";
import { getSalesStatusReport, getConsolidatedReportItemwise, getConsolidatedReportSectionwise } from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import dayjs from "dayjs";
import { useMemo } from "react";
import Branch from "../../../core/json/Branch";
import { Calendar } from "feather-icons-react/build/IconComponents";
import LoadingUtils from "../../../core/utils/LoadingUtils";
import {
  exportnestedExcel,
  exportnestedPDF,
  printnestedReport,
} from "../../../core/utils/NestedReportUtils";
import { exportpandlPDF } from "../../../core/utils/PandLexport";
import { exportreportPDF } from "../../../core/utils/MainReportUtils";
const SalesStatusReport = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [searchText, setSearchText] = useState("");
  const [reportData, setreportData] = useState([]);
  const [modifiedList, setModifiedList] = useState();
  const [loadingDes, setLoadingDes] = useState(false);
  const [sectionReport,  setSectionReport] =useState([]);
  const [ salesReportData, setSalesReportData]= useState([]);
  // const [modifiedFooterTotals, setModifiedFooterTotals] = useState({});
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const { branch } = useSelector((state) => state.branchlist);
  const dispatch = useDispatch();
  const { TabPane } = Tabs;
 const [decimalpoints, setDecimalPoints] = useState(2);
 const [pageSize, setPageSize] = useState(10);
  const {
    productList,
    unitList,
    settingList,
    customerList,
    formatedproductList,
  } = useSelector((state) => state.usersetting);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
 
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const handleFromDateChange = (date) => {
    setFromDate(date);
 
    setToDate(null);
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };
  useEffect(() => {
    handleReportList();
     dispatch(fetchUnit());
        dispatch(fetchProduct(branch));
        dispatch(fetchTax());
        dispatch(fetchSettings(branch));
   
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
        const currfmt = match ? match[0]?.length - 1 : 0;
        setDecimalPoints(currfmt);
  }, [branch,toDate]);
 
  useEffect(() => {
    handleFilter();
  }, [searchText]);
 
 
  function handleReset() {
    const today = dayjs(); // Get current date using dayjs
   
       setFromDate(today);
       setToDate(today);
    setSearchText("");
    setModifiedList([]);
    detailData = [];
    
  }
 
 
   const handleTabChange = (key) => {
     setActiveTab(key);
   };


   const getActiveTabData = () => {
    const createFieldMapping = (columns) =>
      Object.fromEntries(columns.map(({ title, dataIndex }) => [title, dataIndex]));
    
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    return {
      detaildata: detailData, // First Table Data
      summaryData: sectionSummaryData, // Second Table Data (Ensure summaryList is defined)
      thirdData: columnThreeData, // Third Table Data (Ensure thirdList is defined)
      detailColumns,
      summaryColumns,
      thirdColumns,
      footerTotals,
      footerTotals2,
      footerThreeTotals,
      currfmt,
      fieldMapping: {
        detail: createFieldMapping(detailColumns),
        summary: createFieldMapping(summaryColumns),
        third: createFieldMapping(thirdColumns),
      },
    };
  };
  

  
  const handleReportList = async () => {
    setLoadingDes(true);
     if (!fromDate || !toDate) {
       console.warn("Please select both From and To dates");
      setLoadingDes(false);
      return;
    }
    const DatatablePagingParameters = new DatatablePagingParameter();
    const branchobj = new Branch();
    const formattedfromDate = dayjs(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).endOf("day").format("YYYY-MM-DD");
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const Filters = new Filterclass();
 
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
 
    try {
     // console.log(Filters)
      const response = await getSalesStatusReport({
        DatatablePagingParameters,
        Filters,
      });
      const consolidatedReportSectionwise= await getConsolidatedReportSectionwise({
        DatatablePagingParameters,
        Filters,
      })
      setLoadingDes(false);
      const salesReportConsol = consolidatedReportSectionwise?.data?.salesReportConsol || [];
      const salesStatusReportDetail =response?.data?.salesReportDetail || [];
    //  console.log("obggggggggg",salesStatusReportDetail)
         if (Array.isArray(salesReportConsol)) {
             // console.log("object",salesReportConsol)
              const saleArray = salesReportConsol?.map((item) => {
                 const refund = item.refund ? item.netTotal : 0.0;
                 const cancelled = item.cancelled ? item.netTotal : 0.0;
                 const discount = item.discount ? item.discount: 0.0;
                 const complementary =  item.paymentType == 5 ? item.netTotal : 0.0;
                 const extra = item.extra ? item.extra: 0.0;
                 const gross=item.rateTotal + extra - discount;
           const taxAmount = item.taxAmount ? item.taxAmount : 0.0;

                return{
                branch: item.branch?.name,
                trnDate: dayjs(item?.transactionDate).format("DD MMM YYYY"),
                complementary: item.paymentType == 5 ? item.netTotal : 0.0,
                cancelled: item.cancelled ? item.netTotal : 0.0,
                refund: item.refund ? item.netTotal : 0.0,
                gross: item.rateTotal+extra-discount,
                discount: item.discount,
            taxAmount: item.taxAmount ? item.taxAmount : 0.0,

                // netTotal: gross-cancelled-complementary-refund,
                netTotal: Number(
  (gross + taxAmount - cancelled - complementary - refund).toFixed(3)
),
               // netTotal:item.netTotal,
                total:item.rateTotal,
                cash: item.cash-refund-cancelled < 0 ? 0: item.cash-refund-cancelled,
                card: item.card-refund-cancelled < 0 ? 0: item.card-refund-cancelled,
               credit: item.paymentType == 4 ? item.netTotal-refund-cancelled < 0? 0:item.netTotal-refund-cancelled  : 0.0,
               extra:item.extra? item.extra : 0.0,
                }
              })
      //console.log("dataarray",saleArray);
              setSalesReportData(saleArray);
            } else {
              console.error("Data is not in the expected array format");
              setSalesReportData([]);
            }
         
       
      if (Array.isArray(salesStatusReportDetail)) {
   
    const dataArray = salesStatusReportDetail
  ?.filter(item => item.salesStatus === 0) // Filter items where salesStatus is 0
  .map((item) => {
    const refund = item.refund ? item.netTotal : 0.0;
    const cancelled = item.cancelled ? item.netTotal : 0.0;
    const discount = item.discount;
    const complementary = item.paymentType == 5 ? item.netTotal : 0.0;
    const extraCharge = item.otherCharges;
    const gross = item.rateTotal + extraCharge - discount;
 
    return {
      branch: item?.branch?.name,
      section: item?.section?.name,
      netTotal: gross - cancelled - complementary - refund,
      paymenttt: item?.paymentType,
      paymentCardName: item?.paymenCardType?.cardName,
      complementary: item.paymentType == 5 ? item.netTotal : 0.0,
      cancelled: item.cancelled ? item.netTotal : 0.0,
      refund: item.refund ? item.netTotal : 0.0,
      gross: item.rateTotal + item.otherCharges - item.discount,
      discount: item.discount,
      roundOff: item?.roundOff,
      cash: item.cash - refund < 0 ? 0 : item.cash - refund,
      card: item.card - refund < 0 ? 0 : item.card - refund,
      credit: item.paymentType == 4 ? (item.netTotal - refund < 0 ? 0 : item.netTotal - refund) : 0.0,
      total: item.rateTotal,
      extraCharge: item.otherCharges,
      salesstatus: item.salesStatus
    };
  });
 
//console.log(dataArray);
 
   
   
   
    const sectionData = salesStatusReportDetail
        .filter((item) => (item?.paymentType ==4 && item?.salesStatus==0)) // Filter only credit sales
        .map((item) => ({
          branch: item?.branch?.name,
          section: item?.section?.name,
          netTotal: item?.netTotal,
        }));
   // console.log(sectionData,"zaaaaaaaaa");
   
      // console.log("Filtered Credit Sales Data", sectionData);
 
        // console.log("dataarra",dataArray)
        setSectionReport(sectionData);
        setreportData(dataArray);
      } else {
        console.error("Data is not in the expected array format");
        setreportData([]);
      }
    } catch (error) {
      console.error(error?.response?.data?.Message || "Something went wrong");
      setreportData([]);
      setLoadingDes(false);
    }
  };
 const { branches, sections, tableData,dataMap, summaryData, sectionGrandTotal } =
    useMemo(() => {
      const branches = [...new Set(reportData?.map((item) => item.branch))];
      const sections = [...new Set(sectionReport?.map((item) => item?.section))];
     
      const dataMap = sectionReport.reduce((acc, item) => {
        if (!acc[item.branch]) acc[item.branch] = {};
        if (!acc[item.branch][item.section]) acc[item.branch][item.section] = 0;
        acc[item.branch][item.section] += item.netTotal;
        return acc;
      }, {});
     // console.log(dataMap,"xaaaaaaaaa")
      const tableData = branches?.map((branch) => {
        const row = { key: branch, branch };
        let totalCreditSales = 0;
        sections.forEach((section) => {
          const netTotal = dataMap[branch]?.[section] || 0;
          row[section] = netTotal;
          totalCreditSales += netTotal;
        });
        // console.log(tableData,"taaaaaaaa");
       
        row.totalCreditSales = totalCreditSales;
      //  console.log(totalCreditSales,"tooooootal")
        return row;
      });
     
      let summaryData = sections?.map((section) => {
        const sectionTotal = reportData
          .filter((item) => item.section === section)
          .reduce((sum, item) => sum + item.netTotal, 0);
       //   console.log("section total:",sectionTotal)
        return { key: section, section, sectionTotal };
      });
    // console.log(summaryData,"sooooooooo");
     
      const sectionGrandTotal = summaryData.reduce(
        (sum, row) => sum + row.sectionTotal,0);
      const grandTotal = tableData.reduce(
        (sum, row) => sum + row.branchTotal, 0);
      const totalRow = {
        key: "total",
        section: "Total",
        sectionTotal: sectionGrandTotal,
      };
 
    //  console.log(sectionGrandTotal,"granddddddd");
     
      summaryData.push(totalRow);
      const lastRow = { key: "sectionTotal", branch: "Section Totals" };
      sections.forEach((section) => {
        const totalForSection =
          summaryData?.find((s) => s.section === section)?.sectionTotal || 0;
        lastRow[section] = totalForSection;
      });
      //console.log(lastRow,"laaaaaaaast");
     
      lastRow.branchTotal = grandTotal.toFixed(decimalpoints);
      tableData.push(lastRow);
      return { branches, sections, tableData, summaryData, sectionGrandTotal };
    }, [reportData]);
   // console.log(tableData,"taaaaaable");
   
  const sectionModifiedList = Array.isArray(tableData)
    ? tableData?.filter((value) =>
        value.branch?.toLowerCase().includes(searchText?.toLowerCase())
      )
    : [];
 
 
  const {  columnThreeData } = useMemo(() => {
  const safeReportData = Array.isArray(salesReportData) ? salesReportData : [];
 
  const branchSummary = {};
 
  safeReportData.forEach(({ branch, complementary,extra, cancelled, refund, gross,total, discount, netTotal, cash, card, credit, roundOff }) => {
    if (!branch) return;
 
    if (!branchSummary[branch]) {
      branchSummary[branch] = {
        key: branch,
        branch,
        complementary: 0,
        cancelled: 0,
        refund: 0,
        gross: 0,
        discount: 0,
        netTotal: 0,
        cash: 0,
        card: 0,
        credit: 0,
        roundOff: 0,
        total:0,
        extra:0,
      };
    }
 
    branchSummary[branch].complementary += complementary || 0;
    branchSummary[branch].cancelled += cancelled || 0;
    branchSummary[branch].refund += refund || 0;
    branchSummary[branch].gross += gross || 0;
    branchSummary[branch].discount += discount || 0;
    branchSummary[branch].netTotal += netTotal || 0;
    branchSummary[branch].cash += cash || 0;
    branchSummary[branch].card += card || 0;
    branchSummary[branch].credit += credit || 0;
    branchSummary[branch].roundOff += roundOff || 0;
    branchSummary[branch].total += total || 0;
    branchSummary[branch].extra += extra || 0;
  });
 
//console.log(safeReportData,"sum");
 
  return {
    branches: Object.keys(branchSummary),
    columnThreeData: Object.values(branchSummary),
  };
}, [salesReportData]);
//console.log(columnThreeData,"treeedata");
 
const grandcomplementary = salesReportData?.reduce(
  (sum, record) => sum + record.complementary,
  0
);
const grandextraCharge = salesReportData?.reduce(
  (sum, record) => sum + record.extra,
  0
);
const grandcancelled = salesReportData?.reduce(
  (sum, record) => sum + record.cancelled,
  0
);
const grandrefund =salesReportData?.reduce(
  (sum, record) => sum + record.refund,
  0
);
const grandroundOff = salesReportData?.reduce(
  (sum, record) => sum + record.refund,
  0
);
const grandgross = salesReportData?.reduce((sum, record) => sum + record.gross, 0);
const granddiscount = salesReportData?.reduce(
  (sum, record) => sum + record.discount,
  0
);
const grandnetTotal = salesReportData?.reduce(
  (sum, record) => sum + record.netTotal,
  0
);
const grandcash = salesReportData?.reduce((sum, record) => sum + record.cash, 0);
const grandcard = salesReportData?.reduce((sum, record) => sum + record.card, 0);
const grandcredit =salesReportData?.reduce(
  (sum, record) => sum + record.credit,
  0
);
const grandtotal = salesReportData?.reduce(
  (sum, record) => sum + record.total,
  0
);
 
const footerThreeTotals = {
  total:grandtotal?.toFixed(decimalpoints) || 0,
  cash: grandcash?.toFixed(decimalpoints) || 0,
  card: grandcard?.toFixed(decimalpoints) || 0,
  credit: grandcredit?.toFixed(decimalpoints) || 0,
  complementary: grandcomplementary?.toFixed(decimalpoints) || 0,
  cancelled: grandcancelled?.toFixed(decimalpoints) || 0,
  refund: grandrefund?.toFixed(decimalpoints) || 0,
  gross: grandgross?.toFixed(decimalpoints) || 0,
  discount: granddiscount?.toFixed(decimalpoints) || 0,
  roundOff: grandroundOff?.toFixed(decimalpoints) || "0.00", // Add this
  netTotal: grandnetTotal?.toFixed(decimalpoints) || "0.00", // Add this
  extra:grandextraCharge?.toFixed(decimalpoints) || "0.00",
};


// console.log(footerThreeTotals,"sum")
 
//second column
const processSummaryData = (sectionData) => {
  const groupedData = {};
let totalCreditSales = 0;
  sectionData.forEach(({ branch, section, netTotal }) => {
    if (!branch || !section) return;
 
    if (!groupedData[branch]) {
      groupedData[branch] = {
         branch, 
         totalCreditSales:0 };
    }
 
    if (!groupedData[branch][section]) {
      groupedData[branch][section] = 0;
    }
 
    groupedData[branch][section] += netTotal;
    groupedData[branch].totalCreditSales+= netTotal;
    totalCreditSales+=netTotal;
  });
 
  return {tableData :Object.values(groupedData),totalCreditSales};
};
const { tableData: sectionSummaryData, totalCreditSales } = processSummaryData(sectionReport);
 
 const processDetailData = (dataArray) => {
  const groupedData = {};
  let totalAmount = 0;
  dataArray.forEach(({ branch,card, paymentCardName }) => {
    if (!branch || !paymentCardName || paymentCardName === 'Cash') return; // Ignore invalid data
    if (!groupedData[branch]) {
      groupedData[branch] = {
        branch,
   
        totalAmount: 0,
      };
     // console.log("hhhhhhhh",groupedData)
    }
    // Aggregate sales based on payment type
    if (!groupedData[branch][paymentCardName]) {
      groupedData[branch][paymentCardName] = 0;
    }
    groupedData[branch][paymentCardName] += card;
    // Update total amount for each branch
    groupedData[branch].totalAmount += card;
    totalAmount+=card;
  });
  return {tableData: Object.values(groupedData),totalAmount}; // Convert object to array format
};
let {tableData: detailData,totalAmount} = processDetailData(reportData);
// Extract unique branches & sections
const uniqueBranches = [...new Set(reportData.map((item) => item.branch))];
const uniqueSections = [...new Set(reportData.map((item) => item?.section))];
 
 
 
 
 
 
const footerTtotals = {};
uniqueSections.forEach((section) => {
  footerTtotals[section] = summaryData.reduce(
    (sum, item) => sum + (item[section] || 0),
    0
  );
});
 
 const paymentCardTypes = [
   ...new Set(
    reportData
    .filter((item) => item.paymentCardName !== 'Cash')
    .map((item) => item.paymentCardName)
),
];
//console.log(footerTtotals,"uuuuuuuuuuuuuuu");
 
const calculateFooterTotals = (data) => {
  const footerTotals = {
    netTotal: 0,   // Total Net Sales
    netQuantity: 0, // Total Quantity (if needed)
    paymentTotals: {}, // Store totals for each payment type
  };
 
  // Initialize payment totals for each card type
  paymentCardTypes.forEach((cardType) => {
    footerTotals[cardType] = 0;
  });
 
  // Compute column-wise totals
  data.forEach((item) => {
    footerTotals.netTotal += item.netTotal || 0;  // Summing Net Sales
    footerTotals.netQuantity += item.netQuantity || 0;  // Summing Quantity (if applicable)
 
    // Summing card sales per payment type
    paymentCardTypes.forEach((cardType) => {
      if (item&& item[cardType]) {
        footerTotals[cardType] += item[cardType];
      }
    });
  });
 
  return footerTotals;
};
 
 
let footerTotals = calculateFooterTotals(detailData);
//console.log(footerTotals,"foooooooooooterrrr")
 
 
 
 
const calculateFooterTotals2 = (data, sections) => {
  const footerTotals2 = {
    netQuantity: 0,  // Total Quantity (if applicable)
    netTotal: 0,     // Total Net Sales
    paymentTotals: {},  // Store totals for each section
  };
 
  // Initialize payment totals for each section
  sections.forEach((section) => {
    footerTotals2[section] = 0;
  });
 
  // Loop through the data to calculate the totals
  data.forEach((item) => {
    // Sum total net sales
    footerTotals2.netTotal += item.netTotal || 0;
 
    // Sum quantity
    footerTotals2.netQuantity += item.netQuantity || 0;
 
    // Loop through sections and sum values for each section
    sections.forEach((section) => {
      footerTotals2[section] += item[section] || 0;
    });
  });
 
  return footerTotals2;
};
 
// Example usage
const footerTotals2 = calculateFooterTotals2(sectionSummaryData, sections);
//console.log(footerTotals2);
 
 

  const handleFilter = () => {
    handleReportList();
 
    const filteredData = detailData?.filter((value) =>
      Object?.values(value)?.some((val) => {
        const lowerCasedSearchText = searchText?.toLowerCase() || "";
 
        const stringMatch =
          typeof val === "string" &&
          val.toLowerCase().includes(lowerCasedSearchText);
 
        const numberMatch =
          typeof val === "number" &&
          val.toString().includes(lowerCasedSearchText);
 
        return stringMatch || numberMatch;
      })
    );
 
    setModifiedList(filteredData);
  };
 
 
 
 
  const detailColumns = [
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (text, record) =>
        record.key === "totalAmount" ? <strong>{text}</strong> : text,
    },
    {
      title: "CARD SALES CATEGORY",
      children: paymentCardTypes.map((cardType) => ({
        title: cardType, 
        dataIndex:  cardType,
        key: cardType,
        // render: (paymentTypes) =>
        //   paymentTypes?.[cardType] !== undefined
        //     ? paymentTypes[cardType].toFixed(2)
        //     : "0.00",
        render: (value,record) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
      })),
    },
    {
      title: "Total Card Sales",
      key: "totalAmount",
      dataIndex: "totalAmount",
      render: (totalAmount) =>
        totalAmount !== undefined ? totalAmount.toFixed(decimalpoints) : "0.00",
    },
  ];
 
  const summaryColumns = [
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (text, record) =>
        record.key === "sectionTotal" ? <strong>{text}</strong> : text,
    },
    {
      title: "CREDIT SALES CATEGORY",
      children:sections.map((section) => ({
      title: section,
      dataIndex: section,
      key: section,
      render: (value, record) => (value !== undefined ? value.toFixed(decimalpoints) : 0),
    })),
  },
    {
      title: "Total Credit Sales",
      dataIndex: "totalCreditSales",
      key: "totalCreditSales",
      render: (value, record) =>
        record.key === "sectionTotal" ? (
          <strong>{value}</strong>
        ) : value !== undefined ? (
          value.toFixed(decimalpoints)
        ) : (
          0
        ),
    },
  ];
  const thirdColumns = [
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Extracharge",
      dataIndex: "extra",
      key: "extra",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      key: "discount",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Gross",
      dataIndex: "gross",
      key: "gross",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Complementary",
      dataIndex: "complementary",
      key: "complementary",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Cancelled",
      dataIndex: "cancelled",
      key: "cancelled",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Refund",
      dataIndex: "refund",
      key: "refund",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "NetTotal",
      dataIndex: "netTotal",
      key: "netTotal",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Cash",
      dataIndex: "cash",
      key: "cash",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Card",
      dataIndex: "card",
      key: "card",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
    {
      title: "Credit",
      dataIndex: "credit",
      key: "credit",
      render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    },
 
    // {
    //   title: "Round Off",
    //   dataIndex: "roundOff",
    //   key: "roundOff",
    //   render: (value) => (value !== undefined ? value.toFixed(decimalpoints) : "0.00"),
    // },
   
   
  ];
 
 

// const exportreportPDF = () => {
//   const { 
//     detaildata, 
//     summaryData, 
//     thirdData, 
//     detailColumns, 
//     summaryColumns, 
//     thirdColumns 
//   } = getActiveTabData();

//   const doc = new jsPDF("p", "mm", "a4");

//   // Function to flatten nested columns (e.g., "CARD SALES CATEGORY - VISA")
//   const flattenColumns = (columns) => {
//     let flatColumns = [];
//     columns.forEach(col => {
//       if (col.children) {
//         col.children.forEach(child => {
//           flatColumns.push({
//             title: `${col.title} - ${child.title}`,  // Combine parent & child titles
//             dataIndex: Array.isArray(child.dataIndex) ? child.dataIndex.join(".") : child.dataIndex // Support nested keys
//           });
//         });
//       } else {
//         flatColumns.push({
//           title: col.title,
//           dataIndex: Array.isArray(col.dataIndex) ? col.dataIndex.join(".") : col.dataIndex
//         });
//       }
//     });
//     return flatColumns;
//   };
 
//   const formatTableData = (data, columns) => {
//     return data.map(row => 
//       columns.map(col => {
//         let value = col.dataIndex.includes(".") 
//           ? col.dataIndex.split(".").reduce((obj, key) => obj?.[key], row) 
//           : row[col.dataIndex];
  
//         return value !== undefined ? value : "0.00";
//       })
//     );
//   };
//   console.log(formatTableData,"formattable")
//   // Function to generate table with summary
  
//   const addTableWithSummary = (title, data, columns, footerTotals, startY) => {
//     console.log("data",data)
//     const flatColumns = flattenColumns(columns); // Flatten nested columns
//     const formattedData = formatTableData(data, flatColumns); doc.text(title, 14, startY);
//     doc.autoTable({
//       startY: startY + 5,
//       head: [flatColumns.map(col => col.title)],
//       body: data.map(row => flatColumns.map(col => row[col.dataIndex] || "0.00")),
//       styles: { fontSize: 8 },
//       theme: "striped",
//     });

//     // Add Summary Row
//     const finalY = doc.lastAutoTable.finalY + 5;
//     if (footerTotals) {
//       console.log("toooo",footerTotals)
//       doc.text("Total", 8, finalY);
//       doc.autoTable({
//         startY: finalY + 5,
//         body: [
//           flatColumns.map(col => (footerTotals[col.dataIndex] !== undefined 
//             ? footerTotals[col.dataIndex] 
//             : " "))
//         ],
//         styles: { fontSize: 8, fontStyle: "bold" },
//         theme: "grid",
//       });
//     }

//     return doc.lastAutoTable.finalY + 10;
//   };

//   let startY = 10;
//   startY = addTableWithSummary(" ", detaildata, detailColumns, footerTotals, startY);
//   startY = addTableWithSummary(" ", summaryData, summaryColumns, footerTotals2, startY);
//   addTableWithSummary(" ", thirdData, thirdColumns, footerThreeTotals, startY);

//   doc.save("Sales_Status_Report.pdf");
// };

// const exportReportExcel = () => {
//   const {
//     detaildata,
//     summaryData,
//     thirdData,
//     detailColumns,
//     summaryColumns,
//     thirdColumns,
//     footerTotals,
//     footerTotals2,
//     footerThreeTotals,
//   } = getActiveTabData();

//   const flattenColumns = (columns) => {
//     let flatColumns = [];
//     columns.forEach((col) => {
//       if (col.children) {
//         col.children.forEach((child) => {
//           flatColumns.push({
//             title: `${col.title} - ${child.title}`,
//             dataIndex: Array.isArray(child.dataIndex)
//               ? child.dataIndex.join(".")
//               : child.dataIndex,
//           });
//         });
//       } else {
//         flatColumns.push({
//           title: col.title,
//           dataIndex: Array.isArray(col.dataIndex)
//             ? col.dataIndex.join(".")
//             : col.dataIndex,
//         });
//       }
//     });
//     return flatColumns;
//   };

//   const formatTableData = (data, columns) => {
//     return data.map((row) => {
//       let formattedRow = {};
//       columns.forEach((col) => {
//         let value = col.dataIndex.includes(".")
//           ? col.dataIndex.split(".").reduce((obj, key) => obj?.[key], row)
//           : row[col.dataIndex];
//         formattedRow[col.title] = value !== undefined ? value : "0.00";
//       });
//       return formattedRow;
//     });
//   };

//   const workbook = XLSX.utils.book_new();
//   const combinedData = [];

//   const processData = (data, columns, footerTotals, sectionTitle) => {
//     const flatColumns = flattenColumns(columns);
//     const formattedData = formatTableData(data, flatColumns);
//     if (footerTotals) {
//       let footerRow = {};
//       flatColumns.forEach((col) => {
//         footerRow[col.title] = footerTotals[col.dataIndex] || "";
//       });
//       formattedData.push(footerRow);
//     }
//     combinedData.push([{ title: sectionTitle }], ...formattedData, []);
//   };

//   processData(detaildata, detailColumns, footerTotals, "Detail Data");
//   processData(summaryData, summaryColumns, footerTotals2, "Summary Data");
//   processData(thirdData, thirdColumns, footerThreeTotals, "Third Data");

//   const sheet = XLSX.utils.json_to_sheet(combinedData.flat(), {
//     skipHeader: false,
//   });
//   XLSX.utils.book_append_sheet(workbook, sheet, "Sales Report");

//   XLSX.writeFile(workbook, "Sales_Status_Report.xlsx");
// };


// const exportReportExcel = () => {
//   const {
//     detaildata,
//     summaryData,
//     thirdData,
//     detailColumns,
//     summaryColumns,
//     thirdColumns,
//     footerTotals,
//     footerTotals2,
//     footerThreeTotals,
//   } = getActiveTabData();

//   const flattenColumns = (columns) => {
//     let flatColumns = [];
//     columns.forEach((col) => {
//       if (col.children) {
//         col.children.forEach((child) => {
//           flatColumns.push({
//             title: `${col.title} - ${child.title}`,
//             dataIndex: Array.isArray(child.dataIndex)
//               ? child.dataIndex.join(".")
//               : child.dataIndex,
//           });
//         });
//       } else {
//         flatColumns.push({
//           title: col.title,
//           dataIndex: Array.isArray(col.dataIndex)
//             ? col.dataIndex.join(".")
//             : col.dataIndex,
//         });
//       }
//     });
//     return flatColumns;
//   };

//   const formatTableData = (data, columns) => {
//     return data.map((row) => {
//       let formattedRow = {};
//       columns.forEach((col) => {
//         let value = col.dataIndex.includes(".")
//           ? col.dataIndex.split(".").reduce((obj, key) => obj?.[key], row)
//           : row[col.dataIndex];
//         formattedRow[col.title] = value !== undefined ? value : "0.00";
//       });
//       return formattedRow;
//     });
//   };

//   const workbook = XLSX.utils.book_new();
//   const combinedData = [];

//   const processData = (data, columns, footerTotals, sectionTitle) => {
//     const flatColumns = flattenColumns(columns);
//     const formattedData = formatTableData(data, flatColumns);
//     if (footerTotals) {
//       let footerRow = {};
//       flatColumns.forEach((col) => {
//         footerRow[col.title] = footerTotals[col.dataIndex] || "";
//       });
//       formattedData.push(footerRow);
//     }
//     combinedData.push([{ title: sectionTitle }], ...formattedData, []);
//   };

//   processData(detaildata, detailColumns, footerTotals, "Detail Data");
//   processData(summaryData, summaryColumns, footerTotals2, "Summary Data");
//   processData(thirdData, thirdColumns, footerThreeTotals, "Third Data");

//   const sheet = XLSX.utils.json_to_sheet(combinedData.flat(), {
//     skipHeader: false,
//   });
//   XLSX.utils.book_append_sheet(workbook, sheet, "Sales Report");

//   XLSX.writeFile(workbook, "Sales_Status_Report.xlsx");
// };



// const exportReportExcel = () => {
//   const {
//     detaildata,
//     summaryData,
//     thirdData,
//     detailColumns,
//     summaryColumns,
//     thirdColumns,
//     footerTotals,
//     footerTotals2,
//     footerThreeTotals,
//   } = getActiveTabData();

//   const flattenColumns = (columns) => {
//     let flatColumns = [];
//     columns.forEach((col) => {
//       if (col.children) {
//         col.children.forEach((child) => {
//           flatColumns.push({
//             title: `${col.title} - ${child.title}`,
//             dataIndex: Array.isArray(child.dataIndex)
//               ? child.dataIndex.join(".")
//               : child.dataIndex,
//           });
//         });
//       } else {
//         flatColumns.push({
//           title: col.title,
//           dataIndex: Array.isArray(col.dataIndex)
//             ? col.dataIndex.join(".")
//             : col.dataIndex,
//         });
//       }
//     });
//     return flatColumns;
//   };

//   const formatTableData = (data, columns, footerTotals) => {
//     let formattedData = data.map((row) => {
//       let formattedRow = {};
//       columns.forEach((col) => {
//         let value = col.dataIndex.includes(".")
//           ? col.dataIndex.split(".").reduce((obj, key) => obj?.[key], row)
//           : row[col.dataIndex];
//         formattedRow[col.title] = value !== undefined ? value : "0.00";
//       });
//       return formattedRow;
//     });

//     if (footerTotals) {
//       let footerRow = {};
//       columns.forEach((col) => {
//         footerRow[col.title] = footerTotals[col.dataIndex] !== undefined 
//           ? footerTotals[col.dataIndex] 
//           : "";
//       });
//       formattedData.push(footerRow);
//     }

//     return formattedData;
//   };

//   const workbook = XLSX.utils.book_new();

//   const addSheet = (sheetName, data, columns, footerTotals) => {
//     const formattedData = formatTableData(data, flattenColumns(columns), footerTotals);
//     const sheet = XLSX.utils.json_to_sheet(formattedData);
//     XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
//   };

//   addSheet("card sale category", detaildata, detailColumns, footerTotals);
//   addSheet("credit sale category", summaryData, summaryColumns, footerTotals2);
//   addSheet(" ", thirdData, thirdColumns, footerThreeTotals);

//   XLSX.writeFile(workbook, "Sales_Status_Report.xlsx");
// };

// const exportreportPDF = () => {
//   const { 
//     detaildata, 
//     summaryData, 
//     thirdData, 
//     detailColumns, 
//     summaryColumns, 
//     thirdColumns,
//     footerTotals, 
//     footerTotals2, 
//     footerThreeTotals
//   } = getActiveTabData();

//   const doc = new jsPDF("p", "mm", "a4");

//   // Function to flatten nested columns
//   const flattenColumns = (columns) => {
//     return columns.flatMap(col =>
//       col.children
//         ? col.children.map(child => ({
//             title: `${col.title} - ${child.title}`,
//             dataIndex: Array.isArray(child.dataIndex) ? child.dataIndex.join(".") : child.dataIndex
//           }))
//         : [{ title: col.title, dataIndex: Array.isArray(col.dataIndex) ? col.dataIndex.join(".") : col.dataIndex }]
//     );
//   };

//   // Function to extract nested values
//   const extractValue = (row, dataIndex) => {
//     return dataIndex.includes(".") 
//       ? dataIndex.split(".").reduce((obj, key) => obj?.[key], row) 
//       : row[dataIndex];
//   };

//   // Function to format table data
//   const formatTableData = (data, columns) => {
//     return data.map(row => columns.map(col => extractValue(row, col.dataIndex) || "0.00"));
//   };

//   // Function to ensure footer row aligns with columns
//   const formatFooterRow = (columns, footerTotals) => {
//     return columns.map((col, index) => {
//       if (index === 0) return "Total"; // Set first column (e.g., "Branch Name") as "Total"
//       return footerTotals?.[col.dataIndex] !== undefined ? footerTotals[col.dataIndex] : "-"; // Use "-" for empty values
//     });
//   };

//   // Function to generate table with summary
//   const addTableWithSummary = (title, data, columns, footerTotals, startY) => {
//     if (!data || !columns || data.length === 0) return startY; // Skip empty tables

//     const flatColumns = flattenColumns(columns);
//     const formattedData = formatTableData(data, flatColumns);

//     doc.text(title, 14, startY);
//     doc.autoTable({
//       startY: startY + 5,
//       head: [flatColumns.map(col => col.title)],
//       body: formattedData,
//       styles: { fontSize: 8 },
//       theme: "striped",
//     });

//     // Add Summary Row if applicable
//     const finalY = doc.lastAutoTable.finalY + 5;
//     if (footerTotals) {
//       const footerRow = formatFooterRow(flatColumns, footerTotals);

//       doc.autoTable({
//         startY: finalY,
//         body: [footerRow], // Footer row matches table column positions
//         styles: { fontSize: 8, fontStyle: "bold" },
//         theme: "plain",
//       });
//     }

//     return doc.lastAutoTable.finalY + 10;
//   };

//   let startY = 10;
//   startY = addTableWithSummary("Detail Data", detaildata, detailColumns, footerTotals, startY);
//   startY = addTableWithSummary("Summary Data", summaryData, summaryColumns, footerTotals2, startY);
//   addTableWithSummary("Third Data", thirdData, thirdColumns, footerThreeTotals, startY);

//   doc.save("Sales_Status_Report.pdf");
// };

// const exportreportPDF = () => {
//   const { 
//     detaildata, 
//     summaryData, 
//     thirdData, 
//     detailColumns, 
//     summaryColumns, 
//     thirdColumns,
//     footerTotals, 
//     footerTotals2, 
//     footerThreeTotals,
//     currfmt
//   } = getActiveTabData();

//   const doc = new jsPDF("p", "mm", "a4");

//   // Function to flatten nested columns while preserving order
//   const flattenColumns = (columns) => {
//     return columns.flatMap(col =>
//       col.children
//         ? col.children.map(child => ({
//             title: `${col.title} - ${child.title}`,
//             dataIndex: Array.isArray(child.dataIndex) ? child.dataIndex.join(".") : child.dataIndex
//           }))
//         : [{ title: col.title, dataIndex: Array.isArray(col.dataIndex) ? col.dataIndex.join(".") : col.dataIndex }]
//     );
//   };

//   // Function to extract nested values from data
//   const extractValue = (row, dataIndex) => {
//     return dataIndex.includes(".") 
//       ? dataIndex.split(".").reduce((obj, key) => obj?.[key], row) 
//       : row[dataIndex];
//   };

//   // Function to format table data in the correct order
//   const formatTableData = (data, columns) => {
//     return data.map(row => columns.map(col => extractValue(row, col.dataIndex) || "0.00"));
//   };

//   // Function to generate the footer row ensuring correct column alignment
//   const formatFooterRow = (columns, footerTotals) => {
//     return columns.map((col, index) => {
//       if (index === 0) return "Total"; // First column (e.g., "Branch Name") should show "Total"
//       return footerTotals?.[col.dataIndex] !== undefined ? footerTotals[col.dataIndex] : "0.00"; // Ensure correct alignment
//     });
//   };

//   // Function to generate tables with properly aligned footer rows
//   const addTableWithSummary = (title, data, columns, footerTotals, startY) => {
//     if (!data || !columns || data.length === 0) return startY; // Skip empty tables

//     const flatColumns = flattenColumns(columns);
//     const formattedData = formatTableData(data, flatColumns);

//     doc.text(title, 14, startY);
//     doc.autoTable({
//       startY: startY + 5,
//       head: [flatColumns.map(col => col.title)],
//       body: formattedData,
//       styles: { fontSize: 8 },
//       theme: "striped",
//     });

//     // Add Footer Row with correct column alignment
//     const finalY = doc.lastAutoTable.finalY + 5;
//     if (footerTotals) {
//       const footerRow = formatFooterRow(flatColumns, footerTotals);

//       doc.autoTable({
//         startY: finalY,
//         body: [footerRow], // Ensure footer aligns with table columns
//         styles: { fontSize: 8, fontStyle: "bold" },
//         theme: "plain",
//       });
//     }

//     return doc.lastAutoTable.finalY + 10;
//   };

//   let startY = 10;
//   startY = addTableWithSummary("Detail Data", detaildata, detailColumns, footerTotals, startY);
//   startY = addTableWithSummary("Summary Data", summaryData, summaryColumns, footerTotals2, startY);
//   addTableWithSummary("Third Data", thirdData, thirdColumns, footerThreeTotals, startY);

//   doc.save("Sales_Status_Report.pdf");
// };

const exportreportPDF = () => {
  const { 
    detaildata, 
    summaryData, 
    thirdData, 
    detailColumns, 
    summaryColumns, 
    thirdColumns,
    footerTotals, 
    footerTotals2, 
    footerThreeTotals,
    currfmt
  } = getActiveTabData();

  const doc = new jsPDF("p", "mm", "a4");

  // Function to flatten nested columns while preserving order
  const flattenColumns = (columns) => {
    return columns.flatMap(col =>
      col.children
        ? col.children.map(child => ({
            title: `${col.title} - ${child.title}`,
            dataIndex: Array.isArray(child.dataIndex) ? child.dataIndex.join(".") : child.dataIndex
          }))
        : [{ title: col.title, dataIndex: Array.isArray(col.dataIndex) ? col.dataIndex.join(".") : col.dataIndex }]
    );
  };

  // Function to extract nested values from data
  const extractValue = (row, dataIndex) => {
    return dataIndex.includes(".") 
      ? dataIndex.split(".").reduce((obj, key) => obj?.[key], row) 
      : row[dataIndex];
  };

  // Function to format numerical values with currfmt decimal points
  const formatValue = (value) => {
    return typeof value === "number" ? value.toFixed(currfmt) : value;
  };

  // Function to format table data in the correct order
  const formatTableData = (data, columns) => {
    return data.map(row => 
      columns.map(col => {
        const value = extractValue(row, col.dataIndex);
        return value !== undefined ? formatValue(value) : "0.00";
      })
    );
  };

  // Function to generate the footer row ensuring correct column alignment
  const formatFooterRow = (columns, footerTotals) => {
    return columns.map((col, index) => {
      if (index === 0) return "Total"; // First column (e.g., "Branch Name") should show "Total"
      const value = footerTotals?.[col.dataIndex];
      return value !== undefined ? formatValue(value) : "0.00"; // Ensure correct alignment
    });
  };

  // Function to generate tables with properly aligned footer rows
  const addTableWithSummary = (title, data, columns, footerTotals, startY) => {
    if (!data || !columns || data.length === 0) return startY; // Skip empty tables

    const flatColumns = flattenColumns(columns);
    const formattedData = formatTableData(data, flatColumns);

    doc.text(title, 14, startY);
    doc.autoTable({
      startY: startY + 5,
      head: [flatColumns.map(col => col.title)],
      body: formattedData,
      styles: { fontSize: 8 },
      theme: "striped",
    });

    // Add Footer Row with correct column alignment
    const finalY = doc.lastAutoTable.finalY + 5;
    if (footerTotals) {
      const footerRow = formatFooterRow(flatColumns, footerTotals);

      doc.autoTable({
        startY: finalY,
        body: [footerRow], // Ensure footer aligns with table columns
        styles: { fontSize: 8, fontStyle: "bold" },
        theme: "plain",
      });
    }

    return doc.lastAutoTable.finalY + 10;
  };

  let startY = 10;
  startY = addTableWithSummary("Detail Data", detaildata, detailColumns, footerTotals, startY);
  startY = addTableWithSummary("Summary Data", summaryData, summaryColumns, footerTotals2, startY);
  addTableWithSummary("Third Data", thirdData, thirdColumns, footerThreeTotals, startY);

  doc.save("Sales_Status_Report.pdf");
};



const exportReportExcel = () => {
  const {
    detaildata,
    summaryData,
    thirdData,
    detailColumns,
    summaryColumns,
    thirdColumns,
    footerTotals,
    footerTotals2,
    footerThreeTotals,
    currfmt
  } = getActiveTabData();

  const flattenColumns = (columns) => {
    return columns.flatMap((col) =>
      col.children
        ? col.children.map((child) => ({
            title: `${col.title} - ${child.title}`,
            dataIndex: child.dataIndex,
          }))
        : [{ title: col.title, dataIndex: col.dataIndex }]
    );
  };

  const formatTableData = (data, columns, footerTotals) => {
   
    let formattedData = data.map((row) => {
      let formattedRow = {};
      columns.forEach((col) => {
        let value = col.dataIndex.includes(".")
          ? col.dataIndex.split(".").reduce((obj, key) => obj?.[key], row)
          : row[col.dataIndex];
        formattedRow[col.title] = value !== undefined ? value : "0.00";
      });
      return formattedRow;
    });

    // Append footer row if totals exist
    if (footerTotals) {
     
      let footerRow = {};
   
      columns.forEach((col ,index) => {
       if (index === 0) {
          footerRow[col.title] = "Total"; // First column should have "Total"
        } else {
          footerRow[col.title] = footerTotals[col.dataIndex]
            ? footerTotals[col.dataIndex]
            : "  "; // Set total value if available
        }
      });
      formattedData.push(footerRow);
    }

    return formattedData;
  };

  const workbook = XLSX.utils.book_new();

  const addSheet = (sheetName, data, columns, footerTotals) => {
    const formattedData = formatTableData(data, flattenColumns(columns), footerTotals);
    const sheet = XLSX.utils.json_to_sheet(formattedData);
    XLSX.utils.book_append_sheet(workbook, sheet, sheetName);
  };

  addSheet("card sale category", detaildata, detailColumns, footerTotals);
  addSheet("credit sale category", summaryData, summaryColumns, footerTotals2);
  addSheet(" total sale category", thirdData, thirdColumns, footerThreeTotals);

  XLSX.writeFile(workbook, "Sales_Status_Report.xlsx");
};

const handlePageSizeChange = (value) => {
  setPageSize(value);
};

const paginationConfig = {
  pageSize: pageSize,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "50", "100"],
  onShowSizeChange: (current, size) => setPageSize(size),
};
  return (
    <div>
      <LoadingUtils loading={loadingDes} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Consolidated Sales Status Reports</h4>
                <h6>Manage sales Status consolidated reports here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <Link
                   onClick={exportreportPDF}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
          
                    <Link onClick={exportReportExcel}>
                  
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <Link
                    onClick={() =>
                      printnestedReport(getActiveTabData,
                        // footerTotals
                      )
                    }
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Refresh")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={() => handleReportList()}
                  >
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
 
          <div className="card table-list-card">
            <div className="card-body m-2">
              <div className="search-set">
                <div className="search-input">
                  <Link to="#" className="btn btn-searchset">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-search"
                    >
                      <circle cx={11} cy={11} r={8} />
                      <line x1={21} y1={21} x2="16.65" y2="16.65" />
                    </svg>
                  </Link>
                  <div
                    id="DataTables_Table_0_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      {" "}
                      <input
                        type="search"
                        className="form-control form-control-sm"
                        placeholder="Search"
                        aria-controls="DataTables_Table_0"
                        value={searchText}
                        onChange={handleSearch}
                      />
                    </label>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-blocks">
                      <label>From Date</label>
                      {/* <Calendar className="info-img" /> */}
                      <DatePicker
                        className="datetimepicker"
                        id="from-date"
                        placeholderText="From Date"
                        selected={fromDate}
                        value={fromDate}
                        onChange={handleFromDateChange}
                        startDate={fromDate}
                        selectsStart
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-blocks">
                      <label>To Date</label>
                      {/* <Calendar className="info-img" /> */}
                      <DatePicker
                        id="to-date"
                        placeholderText="To Date"
                        value={toDate}
                        onChange={handleToDateChange}
                        minDate={fromDate}
                        startDate={fromDate}
                        selectsEnd
                        disabled={!fromDate}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="input-blocks p-3 mt-3">
                  <Link
                    className="btn btn-filters rounded-2 "
                    onClick={handleReportList}
                  >
                    <i data-feather="search" className="feather-search" />{" "}
                    Search{" "}
                  </Link>
                </div>
                <div className="input-blocks mt-3">
                  <button
                    className="btn btn-reset  rounded-2 "
                    onClick={handleReset}
                  >
                    <i
                      data-feather="refresh-cw"
                      className="feather-refresh-cw"
                    />{" "}
                    Reset
                  </button>
                </div>
              </div>
             
              <div className="table-responsive">
         
              <Table
             
  columns={detailColumns}
  dataSource={modifiedList?.length > 0 ? modifiedList : detailData}
  pagination={paginationConfig}
  className="table datanew dataTable no-footer custom-table mb-5"
  summary={() => (
    <Table.Summary.Row>
      {/* First column for label */}
      <Table.Summary.Cell index={0}>
        <strong>Totals</strong>
      </Table.Summary.Cell>
 
      {/* Loop through all footer totals dynamically, excluding netQuantity and netTotal */}
      {Object.keys(footerTotals || {}).map((key, index) => {
        // Skip netQuantity and netTotal
        if (key === "netQuantity" || key === "netTotal") {
          return null;
        }
 
        // Check if the key is an object (like paymentTotals)
        if (typeof footerTotals[key] === "object" && footerTotals[key] !== null) {
          return Object.keys(footerTotals[key]).map((paymentKey, subIndex) => (
            <Table.Summary.Cell key={`${key}-${paymentKey}`} index={index + subIndex + 1}>
              {footerTotals[key][paymentKey] !== undefined 
                ? footerTotals[key][paymentKey].toFixed(decimalpoints) 
                : "0.00"}
            </Table.Summary.Cell>
          ));
        } else {
          return (
            <Table.Summary.Cell key={key} index={index + 1}>
              {footerTotals[key] !== undefined
                ? footerTotals[key].toFixed(decimalpoints)
                : "0.00"}
            </Table.Summary.Cell>
          );
        }
      })}
    </Table.Summary.Row>
  )}
/>
  <Table
                      columns={summaryColumns}
                      dataSource={
                        modifiedList?.length > 0 ? modifiedList : sectionSummaryData
                      }
                      pagination={paginationConfig}
                      className="table datanew dataTable no-footer custom-table mb-5"
                      summary={() => (
                        <Table.Summary.Row>
                          {/* First column for label */}
                          <Table.Summary.Cell index={0}>
                            <strong>Totals</strong>
                          </Table.Summary.Cell>
                   
                          {/* Loop through all footer totals dynamically, excluding netQuantity and netTotal */}
                          {Object.keys(footerTotals2 || {}).map((key, index) => {
                            // Skip netQuantity and netTotal
                            if (key === "netQuantity" || key === "netTotal") {
                              return null;
                            }
                   
                            // Check if the key is an object (like paymentTotals)
                            if (typeof footerTotals2[key] === "object" && footerTotals2[key] !== null) {
                              return Object.keys(footerTotals2[key]).map((paymentKey, subIndex) => (
                                <Table.Summary.Cell key={`${key}-${paymentKey}`} index={index + subIndex + 1}>
                                  {footerTotals2[key][paymentKey] !== undefined 
                                    ? footerTotals2[key][paymentKey].toFixed(decimalpoints) 
                                    : "0.00"}
                                </Table.Summary.Cell>
                              ));
                            } else {
                              return (
                                <Table.Summary.Cell key={key} index={index + 1}>
                                  {footerTotals2[key] !== undefined
                                    ? footerTotals2[key].toFixed(decimalpoints)
                                    : "0.00"}
                                </Table.Summary.Cell>
                              );
                            }
                          })}
                        </Table.Summary.Row>
                      )}
                    />               
              <Table
              className="mb-5"
  columns={thirdColumns}
  dataSource={modifiedList?.length > 0 ? modifiedList : columnThreeData}
  pagination={paginationConfig}
  summary={(pageData) => {
    if (!pageData?.length) return null; // Prevent rendering empty footer
 
    return (
      <Table.Summary fixed>
        <Table.Summary.Row>
          <Table.Summary.Cell index={0} colSpan={1}>
            <b>Total</b>
          </Table.Summary.Cell>
          {thirdColumns.slice(1).map((col, index) => (
            <Table.Summary.Cell key={col.dataIndex} index={index + 1}>
              <b>{footerThreeTotals[col.dataIndex] || "0.00"}</b>
            </Table.Summary.Cell>
          ))}
        </Table.Summary.Row>
      </Table.Summary>
    );
  }}
/>
 
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SalesStatusReport;